type ReadCallback = (errorValue: unknown, translations: unknown) => void;

export function createWebpackBackend() {
	return {
		type: 'backend' as const,
		read(language: string, namespace: string, callback: ReadCallback) {
			import(/* webpackChunkName: "translation-[request]" */ `../locales/${language}/${namespace}.json`)
				.then((resources: { default?: unknown } & Record<string, unknown>) =>
					callback(null, resources.default ?? resources)
				)
				.catch((error: unknown) => callback(error, null));
		},
	};
}
